<template>

  <div class="holder" title="">

    <div class="navigation" style="overflow-y: scroll" title="">


      <h4 style="font-size: 16px">
      {{selectedRackName}}
      </h4>

      <div class="table" ref="table">


        <table>
          <thead>
          <tr>
            <td class="id">
              ID

            </td>
            <td class="photo">Фото</td>
            <td class="title">
              Название

            </td>
            <td class="group">
              Кластер

            </td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="product in products" :class="{'anti-facing': product.noFacing}">
            <td class="id">{{product.groupId}}</td>
            <td class="photo">
              <div class="photo-item"></div>
            </td>
            <td class="title">{{product.title}}
            </td>
            <td class="group">{{product.cluster ? product.cluster.title : ''}}</td>
          </tr>
          </tbody>

        </table>

        <a href="#"
           ref="nextLink"
           @click.prevent="loadNextPage"
           v-if="hasNext"
        >Еще товары</a>

      </div>

    </div>

    <div class="editor-field" title="">
      <div class="plan-holder" title="">
        <div class="added-racks" title="">

          <rack-on-plan
                  v-for="rack in racks"
                  :width="rack.prototype.width"
                  :height="rack.prototype.height"
                  :depth="rack.prototype.depth"
                  :left="rack.startX"
                  :top="rack.startY"
                  :angle="rack.angle"
                  :id="rack.id"
                  :title="rack.title"
                  :selected="rack.selected"
                  :fulfillment="rack.workload"
                  :isExt="rack.isExt"
                  @mousedown="rackClicked"
                  @dblclick="rackDblClicked"
          ></rack-on-plan>
        </div>

        <svg>
          <g>
            <path :d="contour"></path>
            <path v-for="(partition, index) in partitions" :d="partition.str"></path>
          </g>
        </svg>

      </div>
    </div>

  </div>


</template>


<script type="text/javascript">
  /* eslint-disable no-unused-vars,no-plusplus,arrow-body-style,
   no-empty,no-mixed-operators,no-nested-ternary, no-param-reassign,
   no-trailing-spaces, padded-blocks  */
  import axios from 'axios';

  const TYPE_DEF = 0;
  const TYPE_MIDDLE = 1;
  const TYPE_WALL = 2;
  const TYPE_RACK = 3;

  export default {
    name: 'pharmacy-info',
    // apollo: {
    //   products: {
    //     query: gql`
    //         query($endCursor: String, $onlyRemove: Boolean, $onlyAdd: Boolean,
    //         $pharmacy: String, $rack: String, $onlyNeedPlacement: Boolean,
    //         $onlyNeedRemoval: Boolean,
    //         $userId: String
    //         ){
    //         products(first:50, pharmacy: $pharmacy,
    //         rack: $rack,
    //         onlyRemove: $onlyRemove,
    //         showNeedPlacement: $onlyNeedPlacement,
    //         needRemoval: $onlyNeedRemoval,
    //         userId: $userId,
    //         onlyAdd: $onlyAdd, after: $endCursor) {
    //           pageInfo {
    //             hasNextPage
    //             hasPreviousPage
    //             startCursor
    //             endCursor
    //           }
    //           edges {
    //             node {
    //               id,
    //               title,
    //               notInOrder,
    //               cluster{id,title},
    //               groupId,
    //               noFacing
    //               photos {
    //                 edges {
    //                   node {
    //                     photo
    //                   }
    //                 }
    //               },
    //               facinginfo(pharmacy: $pharmacy) {
    //                 facingCount
    //                 facingPlan
    //                 prevCount
    //                 actualCount
    //                 chancheType
    //               }
    //
    //             }
    //       }
    //     }}`,
    //     variables() {
    //       return {
    //         searchStr: this.searchStr,
    //         endCursor: '',
    //         onlyRemove: this.onlyRemove,
    //         onlyAdd: this.onlyAdd,
    //         onlyNeedPlacement: this.onlyNeedPlacement,
    //         pharmacy: this.$route.params.id,
    //         rack: this.rack,
    //         onlyNeedRemoval: this.onlyNeedRemoval,
    //         userId: this.$parent.$parent.$parent.user.id,
    //       };
    //     },
    //     fetchPolicy: 'cache-and-network',
    //   },
    // },
    data() {
      return {
        title: '',
        angleValue: 0,
        angleVisible: false,
        initContourPoints: [],
        guides: [],
        initPartitions: [],
        initRacks: [],
        products: [],
        categories: [],
        currentPage: '/api/products/',
        isLoading: false,
        hasNext: true,
        rack: '',
        selectedRackName: '',
        currentRack: null,
      };
    },
    created() {
      const self = this;
      this.$parent.$on('save', () => {
        self.save();
      });
      this.loadPharmacyInfo();
    },
    methods: {
      loadPharmacyInfo() {
        const that = this;
        axios.get(`/api/v2/pharmacies/${this.$route.params.id}/`).then((response) => {
          that.isLoading = false;
          that.makePlan(response.data);
        });
      },
      makePlan(response) {
        if (response.contour !== null) {
          this.initContourPoints = response.contour;
        }
        if (response.walls !== null) {
          this.initPartitions = response.walls;
        }

        if (response.racks.length > 0) {
          this.initRacks = Object.assign(...response.racks.map(
            o => ({ [o.id]: Object.assign({}, o) }),
          ));
        } else {
          this.initRacks = {};
        }
      },
      loadProducts(rack) {
        const that = this;
        axios.get(`/api/v2/products/?rack=${rack}`).then((response) => {
          that.isLoading = false;
          that.makeProducts(response.data);
        });
      },
      makeProducts(response) {
        this.products = response.results;
      },
      rackClicked(e) {
        if (this.currentRack !== null) {
          this.$set(this.initRacks[this.currentRack.id], 'selected', false);
        }
        if (this.currentRack !== null && this.currentRack.id === e.id) {
          this.currentRack = null;
        } else {
          this.currentRack = e;
          this.$set(this.initRacks[e.id], 'selected', true);
        }
      },
      rackDblClicked(e) {
        this.$router.push(`/pharmacies/${this.$route.params.id}/racks/${e.id}/`);
      },
      planHolderClick() {
        this.currentRack = null;
      },
      runOnScroll() {

      },
      loadNextPage() {
       //
      },
    },
    computed: {
      /* eslint no-param-reassign: ["error",
       { "props": true, "ignorePropertyModificationsFor": ["point"] }] */
      contour() {
        if (this.initContourPoints.length > 0) {
          const points = this.initContourPoints.map((stat, i) => {
            return `${i > 0 ? 'L' : ''} ${stat.x},${stat.y}`;
          }).join(' ');

          return `M ${points} Z`;
        }
        return '';
      },
      partitions() {
        return this.initPartitions.map((line) => {
          line.str = line.map((point, i) => {
            return `${i > 0 ? 'L' : ''} ${point.x},${point.y}`;
          }).join(' ');
          line.str = `M ${line.str}`;
          return line;
        });
      },
      racks() {
        return this.initRacks;
      },
    },
    watch: {
      currentRack(val) {
        if (val !== null) {
          this.rack = val.id;
          this.selectedRackName = `${val.title} (${val.width}x${val.height}x${val.depth})`;

          this.loadProducts(this.rack);
        } else {
          this.rack = '';
          this.selectedRackName = '';
        }

      },
    },
  };
</script>


<style lang="less" scoped>


  .angle-block {
    margin: 20px 0 0 -20px;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 5px 5px 23px 0 rgba(0,0,0,0.38);
  }



.navigation{
  padding: 76px 16px 16px;
  width: 632px;

}

.editor-field{
  left: 632px;
}

  .plan-holder{
    position: relative;
    padding: 10px;
    margin-top: 50px;

    font-size: 14px;
  }

  .plan-item-variants{
    font-size: 0;
    margin: 0 -4px 30px;
  }

  .plan-item__title{
    font-weight: bold;
    font-size: 12px;
    color: #768791;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  .plan-item-section{
    width:64px;
    height:64px;
    display: inline-block;
    background: #fff center no-repeat;
    border-radius: 4px;
    font-size: 0;
    margin:0 4px;

    border: 1px solid #C4CBDF;


    &--active{
      border-color: transparent;
      background: #3F6FA7;
    }

    &--wall{
      background-image: url('/static/assets/wall.svg');
    }

    &--partition{
      background-image: url('/static/partition.svg');
    }
  }

  .wall-point{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #333;
    position: absolute;
    margin: -8px 0 0 -8px;
  }

  .shelf-item{
    &__icon{
      display: inline-block;
      vertical-align: middle;
      width: 24px;
      margin-right: 16px;
    }
    &__title{
      font-size: 18px;
      display: inline-block;
      vertical-align: middle;
      width: 260px;
    }
  }

  svg{
    width: 100%;
    height: 1000px;
  }

  path {
    stroke: #D3D3D4;
    stroke-width: 20px;
    fill: transparent;
  }


.rack-on-plan{
  border:1px solid #88929D;
  border-width: 1px 2px;
  box-sizing: border-box;
  position: absolute;
}


  /*----*/

  .filter{
    margin: 20px 0;
  }

  .filter-name{
    width: 295px;
  }

  table, td{
    padding: 0;
    margin: 0;
    border-collapse: collapse;
    border-spacing: 0;
    vertical-align: top;
    font-size: 12px;
    line-height: 16px;
    box-sizing: border-box;
  }

  thead td{
    text-align: left;
    height: 60px;
    background: #FFFFFF;
    border-bottom: 2px solid #eaeaea;
    vertical-align: middle;
  }

  td{
    padding: 15px 10px;
    height: 44px;
    vertical-align: top;
    text-align: left;
    font-family: 'Roboto', sans-serif;
    border-top:1px solid #eaeaea;
  }

  tbody td{
    /*padding: 15px 10px 0;*/
  }

  .anti-facing td{
    background: rgba(254,223,229,0.4);
    border-top-color:#EBEEF0;
  }

  .id{
    width: 60px;
    border-left:1px solid #eaeaea;
  }

  .photo{
    width: 45px;
  }

  .photo-item{
    width: 40px;
    height: 40px;
    background: #FFFFFF;

  }

  .title{
    width: 250px;
  }

  .group{
    width: 145px;
    border-right:1px solid #eaeaea;
  }

  .notInOrder{
    width: 70px;
  }


  .cats{
    background: #fcfcfc;
    min-width: 40px;
    border-right: 1px solid #eaeaea;
  }

  .sort-arrow{
    color:#ccc;
  }

</style>


// WEBPACK FOOTER //
// PharmacyInfo.vue?6c23c874